import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const siteDefinition: ResourceDefinition = {
  title: 'Sites',
  nameSingular: 'site',
  namePlural: 'sites',
  className: 'Site',
  mainIdentifier: 'name',
  slug: 'sites',
  path: 'sites',
  icon: 'icon-home',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE, LinkType.EXPORT],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editSites',
      action: (site) => ({
        type: ActionType.Link,
        link: {
          path: `${siteDefinition.path}/${site.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteSites',
      action: (site) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: site,
          definition: siteDefinition
        }
      }),
      disabled: (site) => site.usersCount > 0
    }
  ]
}
